import React from 'react';
import { humanFirst } from '../assets/humanFirst';
interface HeroProps {
  onOpenWaitlist: () => void;
}
export const Hero: React.FC<HeroProps> = ({
  onOpenWaitlist
}) => {
  return <section id="top" aria-labelledby="hero-heading" className="bg-white pt-28 pb-12 md:pt-36 md:pb-16 lg:pt-40 lg:pb-20" data-id="element-76" data-mp="9kjx0ppbh647">
      <div className="section-container grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-77" data-mp="4n9zsnvorq5t">
        <div data-id="element-78" data-mp="128pgza8jqr2z">
          <h1 id="hero-heading" className="max-w-[15ch] text-4xl leading-[1.25] tracking-tight sm:text-5xl sm:leading-[1.2] lg:text-6xl lg:leading-[1.2]" data-id="element-79" data-mp="1274p5sdm9m8t">
            Find your people. Build your path forward.
          </h1>
          <p className="mt-6 max-w-[34rem] text-lg leading-relaxed text-plum-gray md:text-xl" data-id="element-80" data-mp="nbez9j5b8oyt">
            We’re building Re:Joy to bring you therapist-led group care that
            fits your needs, preferences, and everyday life.
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row" data-id="element-81" data-mp="3j8ixl0k6uiv8">
            <button type="button" onClick={onOpenWaitlist} className="btn-primary" data-id="element-82" data-mp="3j928hxbf86zr">
              Join the waitlist
            </button>
            <a href="#how-it-works" className="btn-secondary" data-id="element-83" data-mp="39acx8ne15ksh">
              See how it works
            </a>
          </div>
          <p className="mt-6 text-sm text-plum-gray" data-id="element-84" data-mp="3e8mur4n88xh9">
            Re:Joy is in development. Join the waitlist for updates.
          </p>
        </div>

        <div className="flex justify-center lg:justify-end" data-id="element-85" data-mp="30fya5yn9d5yt">
          <img src={humanFirst} alt="Illustration representing human-first, therapist-led group care" className="h-auto w-[280px] object-contain md:w-[360px] lg:w-[440px]" data-id="element-86" data-mp="359sy5e9wc73p" />
        </div>
      </div>
    </section>;
};